
import React, {FC} from 'react';
import {NavProps} from 'components/Header';
import MenuNav, {Browse, Groups, Logout, Welcome} from 'components/Header/MenuNav';

import * as linkStyles from 'components/Header/MenuNav/Group/Link/styles.module.scss';

type MobileNavProps = NavProps & {
	name: string
}

const MobileNav: FC<MobileNavProps> = ({nav, name}) => (
	<MenuNav className={linkStyles.highlightEnable}>
		<Browse nav={nav} />
		<Welcome>{name}</Welcome>
		<Groups nav={nav}>
			{(groups) => (
				<>
					{groups}
					<Logout />
				</>
			)}
		</Groups>
	</MenuNav>
);

export default MobileNav;
